import classNames from 'classnames';
import { IconV1 } from 'common/icon/iconV1.js';
import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';
import { REMOVE_MODULE_NAME } from 'components.modules.gen/placeholder-dataurl/dataUrlHook';
import { MobileHeaderWarning } from 'layout/sections/secondary-section/mobile/mobile-header-warning.js';
import { MobileModuleTitle } from 'layout/sections/secondary-section/mobile/mobile-module-title.js';
import { MobileSecondaryMajorModuleExpandedHook } from 'layout/sections/secondary-section/mobile/mobile-secondary-major-module-wrapper.js';
import { ReactNode, useMemo } from 'react';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { PW_MOBILE_SECONDARY_DRAWER } from 'utilities/consts/variable-types.js';
import { formatUrlSlug } from 'utilities/slugify.js';

export const MobileSecondaryMajorModuleWrapper = ({
  module,
  children,
  wrapInSecondarySectionDrawer,
}: {
  module: IModuleConfig;
  children: ReactNode;
  wrapInSecondarySectionDrawer: boolean;
}) => {
  const props = useMemo(() => {
    const urlSlug = formatUrlSlug({
      urlSlug: module.urlSlug,
      title: module.title,
      name: module.name,
    });
    return {
      title: module.title,
      name: module.name,
      urlSlug,
      expandMobile: module.layout?.expandInMobileView,
    };
  }, [module.title, module.name, module.urlSlug, module.layout?.expandInMobileView]);
  const [isExpanded, setExpanded] = MobileSecondaryMajorModuleExpandedHook(props);

  if (wrapInSecondarySectionDrawer) {
    const { subtitle, link, iconName, title, name } = module;
    if (name === REMOVE_MODULE_NAME) {
      return null;
    }

    return (
      <>
        <li
          // ** We turn off margin bottom when selected as the internal Tile class will add spacing when open
          className={classNames(`DrawerMenu-item ${isExpanded ? 'selected-drawer u-mB-0' : 'u-mB-xs'} `)}
          data-slug={props.urlSlug}
        >
          <MobileHeaderWarning isTabOpen={isExpanded} />

          <div className="DrawerMenu-item-header" onClick={setExpanded}>
            <MobileModuleTitle title={title} iconName={iconName} />
            {isExpanded && (
              <>
                {subtitle && <p className="u-mT-xs u-mB-0">{subtitle}</p>}
                {link?.url && (
                  <p className="u-mT-xs u-mB-0">
                    <LinkFactoryReactRouter className="u-linkClean u-textWhite svg--fill-inherit" href={link.url}>
                      {link?.label} <IconV1 icon="chevron-right" iconClass="svg--1em" />
                    </LinkFactoryReactRouter>
                  </p>
                )}
              </>
            )}
          </div>
          <div
            className="u-flex u-pR-md u-pL-md u-flexAlignItemsCenter svg--fill-inherit"
            data-testid={PW_MOBILE_SECONDARY_DRAWER}
            onClick={setExpanded}
          >
            <IconV1
              iconClass="expander u-inlineBlock svg--1em"
              icon={`${isExpanded ? 'chevron-up' : 'chevron-down'}`}
            />
          </div>
        </li>

        {
          // Use u-hiddenVisually since the element's height can still be read compared to scss display none
          // Reason: if there's an Accordion inside the module then it uses the elements height so it can animate open
        }
        <div className={classNames('selected-drawer', { 'u-hiddenVisually': !isExpanded })}>{children}</div>
      </>
    );
  }
  return children;
};
